export enum ProductDetailsActionType {
  FETCH_PRODUCT_DETAILS = "fetch_product_detail",
  FETCH_PRODUCT_DETAILS_SUCCESS = "fetch_product_detail_success",
  FETCH_PRODUCTS_DETAILS_FAILURE = "fetch_product_detail_failure",
}
